import React, { Fragment, useEffect, useState } from 'react';
import { get } from 'lodash';

import t from '../../../lib/I18n';
import Checkbox from '../../form/Checkbox';
import ValidatedFormField from '../../form/ValidatedField';
import Radio from '../../form/Radio';
import { Button } from 'react-bootstrap';
import Icon from '../../general/Icon';
import { CONSENTS } from '../../../constants/AppConstants';
import { WithLoading } from '../../ui/WithLoading';
import { useConsents } from '../../../hooks/useConsents';
import ExternalLink from '../../general/ExternalLink';
import FormattedHTMLMessage from '../../general/FormattedHTMLMessage';
import ConsentsActions from '../../../actions/ConsentsActions';
import { defaultConsents } from '../../../records/customer/ConsentsForm';

export const Consents = () => {
    const {
        consents,
        consentsForm,
        onCheckNotificationMethod,
        onChangePhoneNumber,
        onChangeIsOver16,
        handleSubmit,
        submitLoading,
        consentsLoading,
        showSubmitButton,
    } = useConsents();

    const [phoneVisited, setPhoneVisited] = useState(false);

    const notificationMethods = get(consents, 'blocks[0].options', []);
    const over16Title = get(consents, 'blocks[1].title', '');
    const over16Choices = get(consents, 'blocks[1].choices', []);
    const isOver16 = consentsForm.get(CONSENTS.OVER_16);
    const privacyPolicyURL = get(consents, 'privacyPolicy.policyUrl');

    /* eslint-disable react-hooks/exhaustive-deps */
    /*
        * Reset the consents form to default when the component unmounts
        * This ensures that the form is reset for the next time it is rendered.
        * This wipes any invalid / unsaved changes to avoid user confusion
    */
    useEffect(() => {
        return () => {
            const resetForm = consentsForm.merge(defaultConsents);
            ConsentsActions.setConsentsForm(resetForm);
        };
    }, []);
    /* eslint-enable react-hooks/exhaustive-deps */

    return (
        <WithLoading isLoading={consentsLoading}>
            <div>
                <p>{t('preference-centre.consents.title')}</p>
                <p>{t('preference-centre.consents.title_2')}</p>
                <ul>
                    {notificationMethods.map((method) => {
                        const { optionId, label } = method;
                        return (
                            <li key={optionId}>
                                <Checkbox
                                    label={label}
                                    aria-label={label}
                                    onChange={onCheckNotificationMethod(method)}
                                    checked={consentsForm.get(optionId)}
                                    value={optionId}
                                />
                            </li>
                        );
                    })}
                </ul>
                {consentsForm.get(CONSENTS.SMS_Marketing) && (
                    <Fragment>
                        <label htmlFor={CONSENTS.PHONE} className="label">
                            {t('preference-centre.consents.phoneNumber')}
                        </label>
                        <ValidatedFormField
                            type="text"
                            form={consentsForm}
                            id={CONSENTS.PHONE}
                            field={CONSENTS.PHONE}
                            className="input-field margin-bottom--sm consents__input"
                            maxLength={21}
                            onChange={(field, value) => {
                                setPhoneVisited(true);
                                const schema = consentsForm.getSchema()[field];
                                if (schema) {
                                    const result = schema.validate(value);

                                    if (result.error) {
                                        // Patch local form state to show validation error
                                        const patchedForm = consentsForm.set(field, value);
                                        ConsentsActions.setConsentsForm(patchedForm);

                                        // Trigger validation display
                                        patchedForm.validateField(field);
                                        return;
                                    }
                                }

                                // Only update if validation passed
                                onChangePhoneNumber(field, value);
                            }}
                            onBlur={() => setPhoneVisited(true)}
                            label={t('preference-centre.consents.phoneNumber')}
                            aria-label={t('preference-centre.consents.phoneNumber.sr')}
                            validation={consentsForm.getValidationSummary()}
                            visited={phoneVisited}
                            required
                        />
                    </Fragment>
                )}
            </div>
            <div>
                <p>{over16Title}</p>
                <p>
                    <strong>{t('preference-centre.consents.confirmAge')}</strong>
                </p>
                <ul>
                    <li>
                        <Radio
                            radioClass="regular-radio"
                            label={get(over16Choices, '[0].label', '')}
                            aria-label={get(over16Choices, '[0].label', '')}
                            checked={isOver16}
                            onChange={onChangeIsOver16(get(over16Choices, '[0]', {}))}
                        />
                    </li>
                    <li>
                        <Radio
                            radioClass="regular-radio"
                            label={get(over16Choices, '[1].label', '')}
                            aria-label={get(over16Choices, '[1].label', '')}
                            checked={!isOver16}
                            onChange={onChangeIsOver16(get(over16Choices, '[1]', {}))}
                        />
                    </li>
                </ul>
            </div>
            <p className="margin-bottom--md">
                <FormattedHTMLMessage
                    message='preference-centre.consents.privacyPolicy'
                    link={
                        <ExternalLink
                            message='preference-centre.consents.privacyPolicyLink'
                            href={ privacyPolicyURL }
                        />
                    }
                />
            </p>
            {showSubmitButton && (
                <Button
                    className="btn-blue"
                    disabled={
                        submitLoading ||
                        (consentsForm.get(CONSENTS.SMS_Marketing) && !!consentsForm.getError(CONSENTS.PHONE))
                    }
                    onClick={handleSubmit}
                >
                    {submitLoading ? (
                        <Icon icon="spinner" className="otrl-spin" />
                    ) : (
                        t('button.text.submit')
                    )}
                </Button>
            )}
        </WithLoading>
    );
};



// WEBPACK FOOTER //
// ./src/components/customer/marketingPrefs/Consents.js